import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      createdAt: 1752072540899,
      error: {
        code: 0,
        label: '',
        message: '',
      },
      object: 'getstatus',
      success: true,
      data: {
        lastFiveOffers: [
          {
            _id: '686e2e60f52b29b1778a1e7e',
            status: 'open',
            createdAt: '2025-07-09T08:54:56.210Z',
            idNumber: '00018',
            fullName: 'שלמה',
          },
          {
            _id: '686a89dc59cd1351647f4992',
            status: 'open',
            createdAt: '2025-07-06T14:36:12.264Z',
            idNumber: '00018',
            fullName: 'שלומית',
          },
          {
            _id: '68652fca40358850fbb812c5',
            status: 'open',
            createdAt: '2025-07-02T13:10:34.315Z',
            idNumber: '00018',
            fullName: 'חזי',
          },
          {
            _id: '68652fc440358850fbb81242',
            status: 'open',
            createdAt: '2025-07-02T13:10:28.135Z',
            idNumber: '00018',
            fullName: 'שרית',
          },
        ],
        open: 4,
        close: 0,
        sentToClient: 0,
      },
    },
    error: {
      response: {
        createdAt: 1701115461239,
        object: 'login',
        success: false,
      },
      status: 500,
    },
  },
};

const userStatusHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(1000);
  return HttpResponse.json(response, status);
};

export {
  userStatusHandler,
};
